import styled from 'styled-components'
import React from 'react'
import FuboFreeTemplate from 'src/components/template/fubofree'
import { leagueIds, ratePlanCodes, sportIds, videos } from 'src/constants'
import { commonCtaText } from 'src/modules/utils/constants'
export default (props) => {
  return (
    <StyledContainer>
      <FuboFreeTemplate
        lang="en"
        market="us"
        location={props.location}
        video={videos.nbatv.videoUrl}
        title="Watch NBA TV with Fubo"
        subtitle={<>Only $8.99/mo. Fubo base plan not required.</>}
        networkSet="standalone_networks"
        maxNetworkCount={7}
        sportId={sportIds.Basketball}
        leagueId={leagueIds.NBA}
        additionalFAQs={additionalFAQs}
        offerCode={ratePlanCodes.nba_tv_mo}
        ctaText={commonCtaText.startWatchingForFree}
      />
    </StyledContainer>
  )
}

const StyledContainer = styled.div`
  .content-container .hero-content {
    max-width: 780px;
  }
`
const additionalFAQs = [
  {
    question: 'What types of games does NBA TV broadcast?',
    answer:
      'NBA TV airs a selection of 60 non-exclusive NBA regular-season games, as well as additional matchups from the WNBA, NBA G League and top U.S. high school competitions.',
  },
  {
    question: 'Does NBA TV offer international basketball coverage?',
    answer:
      'Yes. NBA TV features live and on-demand games from major international leagues including the NBL (Australia/New Zealand), LNB (France), BBL (Germany), Liga ACB (Spain), CBA (China) and KBL (Korea).',
  },
  {
    question: 'Can I watch games on-demand on NBA TV?',
    answer:
      'Yes. NBA TV provides replays, condensed games, and highlight packages that are available on-demand through the NBA App.',
  },
  {
    question: 'What is "The Association"?',
    answer: `"The Association" is NBA TV's flagship weeknight studio show, offering game analysis, storytelling, player insights and interviews. It's filmed in Los Angeles and features a rotating panel including MJ Acosta-Ruiz, David Fizdale, Rudy Gay, Chris Haynes and John Wall.`,
  },
  {
    question: 'What original studio programming does NBA TV offer?',
    answer: `NBA TV produces a variety of original shows, including “Coaches’ Corner,” “Real Training Camp,” “High Tops,” “Shaqtin’ A Fool” and multiple original documentaries such as The Big O.`,
  },
  {
    question: 'Does NBA TV feature documentaries or special long-form content?',
    answer:
      'Yes. NBA TV offers a robust library of original documentaries, historical specials, and deep-dive features covering players, teams and iconic NBA moments.',
  },
  {
    question: 'Will NBA TV continue to show G League and Basketball Africa League games?',
    answer:
      'Yes. NBA TV maintains coverage of both the NBA G League and the Basketball Africa League (BAL) as part of its year-round programming.',
  },
  {
    question: 'Does NBA TV show WNBA content?',
    answer:
      'Yes. WNBA regular-season games return in the spring, along with highlights, player features and analysis.',
  },
  {
    question: 'What creator-driven content is part of NBA TV programming?',
    answer:
      'NBA TV includes digital-first videos from popular basketball creators such as Bree Green, Chris Matthews, Jesser, Jenna Bandy and Tristan Jass.',
  },
  {
    question: 'What podcasts are available on NBA TV?',
    answer:
      "Fans can watch video versions of podcasts including The Athletic's NBA Daily, Thinking Basketball with Ben Taylor, and SiriusXM NBA Radio shows such as The Starting Lineup and NBA Today.",
  },
  {
    question: 'Is NBA TV available 24/7?',
    answer:
      'Yes. NBA TV provides round-the-clock basketball coverage, including live games, replays, studio shows, documentaries, analysis and creator-driven content.',
  },
]
